import type { JSX } from 'react'

export const MinimizeIcon = (): JSX.Element => (
  <use href='#minimizeIcon' height='100%' width='100%' />
)
